import { RootState } from '../store';

export const appLanguageSelector = (state: RootState) => state.language;

export const localeSelector = (state: RootState) => state.language.locale;
